module.exports = __webpack_public_path__ + "poster3.jpg?5f970a741eb966624b5e4bc5f6cc6524";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/poster3.jpg
// module id = 5
// module chunks = 0